var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{'font-weight-bold bg-dark text-white': _vm.data.highlighted}},[_c('td',{attrs:{"data-label":" "}},[_c('strong',[_vm._v("\n      "+_vm._s(_vm.data.title)+"\n    ")])]),_vm._v(" "),_c('td',{attrs:{"data-label":"Total"}},[_vm._v("\n     "+_vm._s(_vm._f("toDollarAmount")(_vm.data.total))+"\n  ")]),_vm._v(" "),_c('td',{attrs:{"data-label":"Count"}},[_vm._v("\n      "+_vm._s(_vm.data.count)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3949d758","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rows/WorkOrderSummary.vue
// module id = 1329
// module chunks = 1